import { Component, Input, OnInit } from '@angular/core'
import { AlertController, LoadingController, ModalController, Platform } from '@ionic/angular'
import { FilesService } from '@services/requests/files/files.service'
import { first } from 'rxjs'
import { environment } from 'src/environments/environment'
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx'
import { File } from '@ionic-native/file/ngx'
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx'
import { FileOpener } from '@ionic-native/file-opener/ngx'

@Component({
  selector: 'app-sample-details',
  templateUrl: './sample-details.page.html',
  styleUrls: ['./sample-details.page.scss']
})
export class SampleDetailsPage implements OnInit {
  @Input() data
  files = []

  messageSupport =
    'Hola%2c+estoy+usando+GoDx+y+requiero+de+soporte+t%c3%a9cnico+en+el+m%c3%b3dulo+de+Historial+con+una+solicitud+de+Toma+de+Muestra'

  constructor(
    public alertController: AlertController,
    private filesService: FilesService,
    private modalController: ModalController,
    public androidPermissions: AndroidPermissions,
    public platform: Platform,
    public file: File,
    public fileOpener: FileOpener,
    public fileTransfer: FileTransfer,
    public loadingController: LoadingController
  ) {}

  ngOnInit() {
    this.loadFiles()
  }

  loadFiles() {
    var sample_id = this.data.id

    this.filesService.getById(sample_id).subscribe(
      (res) => {
        this.files = res.payload.filter((file) => file.type === 0)
      },
      (err) => {}
    )
  }

  download(id) {
    var date = new Date()
    var filename = `Resultado_${id}_${date.getUTCDate()}-${date.getMonth()}-${date.getFullYear()}_${date.getHours()}-${date.getUTCMinutes()}.pdf`
    this.filesService
      .downloadFile(id)
      .pipe(first())
      .subscribe((response: any) => {
        let dataType = response.type
        let binaryData = []
        binaryData.push(response)
        let downloadLink = document.createElement('a')
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, {
            type: dataType
          })
        )
        var url = `${environment.apiUrl}/files/download/request-attachment/${id}`
        if (this.platform.is('desktop') || this.platform.is('mobileweb')) {
          if (filename) downloadLink.setAttribute('download', filename)
          document.body.appendChild(downloadLink)
          downloadLink.click()
        } else if (this.platform.is('android') || this.platform.is('ios')) {
          this.downloadFileDevice(url, filename)
        } /* else if (this.platform.is('ios')) {
          this.downloadFileDevice(url, filename)
        } */
      })
  }

  downloadFile(url: string, filename: string) {
    /*    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
      (result) => { */
    /*if (result.hasPermission) { */
    this.downloadFileDevice(url, filename)
    /*} else {
          this.androidPermissions
            .requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
            .then((r) => {
              if (r.hasPermission) {
                this.downloadFileDevice(url, filename)
              } else {
                const warning_alert = this.alertController.create({
                  header: '',
                  subHeader: "Habilite los permisos de 'Almacenamiento' de 'GoDx' para descargar el archivo.",
                  buttons: ['OK']
                })

                warning_alert.then((res) => {
                  res.present()
                })
              }
            })
        }
      },
      (err) => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
    ) */
  }

  async downloadFileDevice(baseUrl: string, filename: string) {
    const loading = await this.loadingController.create({
      message: 'Espera por favor...',
      translucent: true
    })
    var storage: string
    if (this.platform.is('android')) {
      storage = this.file.dataDirectory + filename
    } else if (this.platform.is('ios')) {
      storage = this.file.documentsDirectory + '/' + filename
    }
    loading.present().then(() => {
      this.platform.ready().then(() => {
        let fTransfer: FileTransferObject = this.fileTransfer.create()
        fTransfer.download(baseUrl, storage).then(
          (entry) => {
            this.fileOpener
              .open(storage, 'application/pdf')
              .then(() => console.log('File is opened'))
              .finally(() => loading.dismiss())
              .catch((e) => {
                console.log('Error opening file', e)
                loading.dismiss()
              })
          },
          (error) => {
            console.log('error', error)
            loading.dismiss()
          }
        )
      })
    })
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
